<template>
  <div  class="avatar-icon-box" >
      <el-popover
        class="box-item"
        placement="bottom-end"
        :width="260"
        popper-class="portal-person-popoverBox"
        ref="portal-person-popoverBox"
      >
        <div class="portal-person-box" ref="AvatarMenuPopover">
            <div class="portal-person-info">
                <avatarHeader ref="avatarHeaderRef" @toHidePopover="toHidePopover"/>
            </div>
            <li
                class="portal-person-one hoverBackgroudColor hoverFontColor"
                style="margin-top: 10px;"
                @click="gotoPath('/user/userInfo')"
            >
                <i class="iconfont icon-gerenshezhi2" style="color:#ff6a00;"></i>
                <span class="person-name">{{$t('msg.personal_setting')}}</span>
            </li>
            <li
                class="portal-person-one hoverBackgroudColor hoverFontColor"
                @click="gotoPath('/user/userInvite')"
            >
                <i class="iconfont icon-yaoqingtongshi" style="color:#df465d;"></i>
                <span class="person-name">{{$t('msg.invite_colleagues')}}</span>
            </li>
            <div class="portal-person-line" ></div>
            <li
                class="portal-person-one hoverBackgroudColor hoverFontColor"
                @click="goDownload('app')"
            >
                <img :src="require('@img/portal/app_icon.png')" alt="">
                <span class="person-name">APP端下载</span>
            </li>
            <li
                class="portal-person-one hoverBackgroudColor hoverFontColor"
                @click="goDownload('pc')"
            >
                <img :src="require('@img/portal/window_icon.png')" alt="">
                <span class="person-name">桌面端下载</span>
            </li>
            <div class="portal-person-line"></div>
            <li
                class="portal-person-one hoverBackgroudColor hoverFontColor"
                @click="logout()"
            >
                <i class="iconfont icon-anquantuichu" style="color:#df465d;"></i>
                <span class="person-name">{{$t('msg.log_out_safely')}}</span>
            </li>
        </div>
        <template #reference>
          <div class="avatar-icon-box" >
            <div :class="{
                'user-name':true,
                'user-name-color' : bgColor=='default',
                'user-name-bg-color' : fontColor=='default',
                }" :style="{width:iconWidth+'px',height:iconWidth+'px',
                'background-color':bgColor!='default' ? bgColor: '','color':fontColor!='default' ? fontColor: '' }"
                v-avatarShow="roleAuth.emp_id" :key="roleAuth.emp_id"
            >
                {{nameByOne()}}
            </div>
            <div class="show-user-name" v-if="isShowName">{{userName}}</div>
          </div>
        </template>
      </el-popover>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const avatarHeader = defineAsyncComponent(() => import("./component/avatarHeader.vue"));
export default {
  components: {
    avatarHeader
  },
  props: {
    isShowName:{
      default(){
         return false
       }
    },
    bgColor:{
        default(){
         return 'default'
       }
    },
     fontColor:{
        default(){
         return 'default'
       }
    },
    iconWidth:{
       default(){
         return 24
       }
    }
  },
  data(){
    return {
        isShowMenu:false,
        roleAuth:{},
        userName:'',
        openAvatarMenuFlag:false,
    }
  },
  created(){
   this.queryUserDtl();
  },
  mounted() {
      this.querySessionMap()
  },
  methods: {
     queryUserDtl(){
      this.$http.post(this.$api.org.user.queryUserDtl,{}).then(res=>{
        this.userName=res.payload.user_name;
      })
    },
     querySessionMap(){
      this.$http.post(this.$api.worktbl.querySessionMap,{}).then(res=>{
        this.roleAuth = res.payload
      })
    },
    logout(){
        this.$http.post(this.$api.org.user.logout, {}).then(() => {
            localStorage.removeItem('autoLoginSet')
            this.$session.delSession();
            this.$router.push('/pub/pswdLogin')
      }).catch(() => {
            localStorage.removeItem('autoLoginSet')
            this.$session.delSession();
            this.$router.push('/pub/pswdLogin')
      })

    },
    nameByOne(){
        if(this.userName){
           return this.userName.slice(-1)
        }else{
            return '-'
        }
    },
    mouseleave(){
      this.isShowMenu=false

    },
    mouseover() {
      this.isShowMenu=true
    },
    gotoPath(path){
      this.$router.push(path)
    },
    goDownload(type) {
      let obj = {
        'pc':'pc/pc.zip',
        'app':'app/app.apk'
      }
      window.open(`${window.origin}/aboutUs/download/${obj[type]}`)
    },
    toHidePopover(){
        this.$refs['portal-person-popoverBox'].hide()
    }
  },
  unmounted(){
  }
}
</script>

<style lang="scss" scoped>
.avatar-icon-box {
   width: 100%;
    height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  .move-box{
    right: 0;
    top: 0;
    position: absolute;
    width: 30px;
    height: 50px;
  }
  .show-user-name{
    margin-left: 8px;
    white-space: nowrap;
  }
  .user-name {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height:24px;
    line-height: 24px;
    border-radius: 50%;
    flex: 0 0 auto;
  }
  .user-name-color{
    color: #ffffff;
  }
    .user-name-bg-color{
    background-color: var(--mainColor);
  }
  .name-icon {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    line-height: 30px;
    background-color: #ff6a00;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    margin: 10px 20px 0 0;
    display: inline-block;
  }

}
</style>
<style lang="scss" >
.portal-person-popoverBox{
    padding: 0!important;
  .portal-person-box {
    font-size: 14px;
    .portal-person-info {
      box-sizing: border-box;
      display: flex;
      border-bottom: 1px solid #dedede;
      align-items: center;
      border-radius: 4px 4px 0 0;
      padding:12px;
      padding-bottom:0;
      /* background-image: var(--bgImage); */
      .portal-person-user-face {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 29px;
        border-radius: 50%;
        span {
          position: absolute;
          display: inline-block;
          color: #ff6a00;
          top: -7px;
          left: 6px;
        }
      }
    }
    .portal-person-one {
      cursor: pointer;
      position: relative;
      height: 35px;
      display: flex;
      align-items: center;
      padding-right: 15px;
      margin-bottom: 2px;
      text-align: left;
      padding-bottom: 2px;
      line-height: 35px;
      color: #575757;
      padding:4px 12px;
      transition:all 0.25s;
      .more-icon {
        position: absolute;
        left: 16px;
        top: 11px;
      }
      i,img {
        margin-right: 15px;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .portal-person-one:hover {
      background-color: var(--lightColor);
      color: var(--mainColor);
    }
    .portal-person-line {
      width: 100%;
      height: 1px;
      background-color: #dee0e3;
      margin: 5px 0;
    }
  }
}
</style>